module.exports = __webpack_public_path__ + "img/Electricite_de_provence_120X35.8882e935.png";